<template>
    <div class="common">
        <!-- 搜索表单 -->
        <search-form :formConfig="formConfig" :source="searchData" @handleSearch="handleSearch" @search="search">
          <template slot="btns">
            <a-button :disabled="selectedRows.length == 0" @click="toBatchPaie()"
                      class="search-btn-item btn-blue-line">批量兑付</a-button>
          </template>
        </search-form>
        <div class="table-common">
            <div class="table-check-bar" v-if="selectedRows.length">
              已选择：
              <span class="text-color-blue">{{ selectedRows.length }} 条</span>
            </div>
            <a-table size="middle" :columns="columns" :row-key="(record, index) => record.id" :data-source="tableData"
                :pagination="pagination" :loading="loading" @change="handleTableChange" bordered
                :scroll="columns.length > 10 ? { x: '100%' } : {}" :locale="{ emptyText: '暂无数据' }" :row-selection="{
                  selectedRowKeys: selectedRowKeys,
                  selectedRows: selectedRows,
                  onChange: onTableChange
                }">
                <template slot="rcvpymtTm" slot-scope="text">{{ text | dateFormat('YYYY-mm-dd') }}</template>
                <template slot="gldAmt" slot-scope="text">{{ text | splitK }}</template>

                <template slot="toPymAmt" slot-scope="text,record">
                  {{ utils.splitK(record.toPymAmt) }}
                </template>
<!--                <template slot="rcvpymtTAmt" slot-scope="text,record">-->
<!--                  {{ utils.splitK(record.rcvpymtTAmt+record.rcvpymtGldInt)}}-->
<!--                </template>-->
<!--                <template slot="toRcvpymtAmt" slot-scope="text,record">-->
<!--                  {{ utils.splitK(record.toRcvpymtAmt+record.toRcvpymtGldInt)}}-->
<!--                </template>-->
              <template slot="rcvpymtAmt" slot-scope="text,record">
                {{ utils.splitK(record.rcvpymtAmt+record.rcvpymtInt)}}
              </template>
              <template slot="exDay" slot-scope="text">{{ text | dateFormat('YYYY-mm-dd') }}</template>
                <template slot="operation" slot-scope="text, record">
                    <a @click="toPaie(record)">兑付</a>
                </template>
            </a-table>
<!--          <div :class="{-->
<!--            'table-total': pagination.total > 0,-->
<!--            'table-total-none': pagination.total == 0-->
<!--          }">-->
<!--            共有记录：-->
<!--            <span class="text-color-blue">{{ pagination.total }} 条</span>-->
<!--            待付金额总数：<span class="text-color-orange">{{ tableDataAmount | splitK }} 元</span>-->
<!--          </div>-->
        </div>

    </div>
</template>

<script>
import { mapGetters } from "vuex"
import { queryGoldPayFailApi,paymentFailGld } from "@/api/gold.js"
import {queryGoldPayFailCount} from "../../api/gold";
export default {
    props: {
    },
    components: {
    },
    name: "gold-checks-paie-exception",
    data() {
        return {
            searchData: {
                estb: "",
                rcPty: "",
                exDay: []
            },
            formConfig: [

                {
                  prop: "estb",
                  type: "selectSearch",
                  label: "开立方",
                  option: [],
                  searchSource: true,
                  valuePorp: "estb",
                  valuePorpReal: "estb",
                  labelPorp: "estbNm",
                  searchHandle: "handleSearch",
                  normal: true
                },
                {
                  prop: "rcPty",
                  type: "selectSearch",
                  label: "持有方",
                  option: [],
                  searchSource: true,
                  valuePorp: "rcPty",
                  valuePorpReal: "rcPty",
                  labelPorp: "rcPtyNm",
                  searchHandle: "handleSearch",
                  normal: true
                },
                {
                  prop: "exDay",
                  type: "dateRange",
                  label: "到期日期",
                },

            ],
            columns: [
                {
                  title: "申请日期",
                  sorter: true,
                  width: "100px",
                  dataIndex: "rcvpymtTm",
                  scopedSlots: { customRender: "rcvpymtTm" },
                },
                {
                  title: "祺信编号",
                  dataIndex: "gldId",
                  ellipsis: true,
                },
                {
                  title: "开立方",
                  dataIndex: "estbNm"
                },
                {
                  title: "担保方",
                  dataIndex: "guarantorNm"
                },
                {
                  title: "持有方",
                  dataIndex: "rcPtyNm"
                },
                {
                  title: "祺信金额(元)",
                  dataIndex: "gldAmt",
                  sorter: true,
                  scopedSlots: { customRender: "gldAmt" }
                },

                // {
                //   title: "已付金额(元)",
                //   dataIndex: "rcvpymtTAmt",
                //   sorter: true,
                //   scopedSlots: { customRender: "rcvpymtTAmt" }
                // },
                // {
                //   title: "待付金额(元)",
                //   dataIndex: "toRcvpymtAmt",
                //   sorter: true,
                //   scopedSlots: { customRender: "toRcvpymtAmt" }
                // },
                {
                  title: "本次支付金额(元)",
                  dataIndex: "rcvpymtAmt",
                  sorter: true,
                  scopedSlots: { customRender: "rcvpymtAmt" }
                },
                {
                    title: "到期日期",
                    dataIndex: "exDay",
                    width: "100px",
                    scopedSlots: { customRender: "exDay" },
                },

                {
                    title: "失败原因",
                    dataIndex: "msg"
                },

                {
                    title: "操作",
                    dataIndex: "operation",
                    width: 80,
                    scopedSlots: { customRender: "operation" },
                },
            ],
            tableData: [],
            pagination: {
                pageSize: 10,
                current: 1,
                sortField: "exDay",
                sortOrder: "ascend",
                total: 0,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['5', '10', '20', '50', '100'],
                showTotal: (total) => {
                    return `共 ${total} 条`
                }
            },
            loading: false,
            selectedRows: [],
            selectedRowKeys: [],
            tableDataAmount: 0,
        }
    },
    computed: {

        ...mapGetters({

            userObj: "home/getUserObj"

        })
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        handleSearch(value, data) {
            this.getDataList(value);
        },
        onTableChange(selectedRows, data) {
          //表格选择回调
          this.selectedRowKeys = selectedRows;
          this.selectedRows = this.tableData.filter(
            item => selectedRows.indexOf(item.id) > -1
          );
        },
        handleTableChange(pagination, filters, sorter) { //表格排序回调
          this.pagination = {
            current: pagination.current,
            pageSize: pagination.pageSize,
            sortField: sorter.field,
            sortOrder: sorter.order,
            total: this.pagination.total || 0,
          };
          this.getTableData();
        },
        getDataList(value) { //下拉筛选
          if(this.tableData){
            //开立方
            let estbs = this.tableData.map(item => {
              return {
                estb: item.estb,
                estbNm: item.estbNm
              };
            });
            const uniqueMap0 = new Map();
            estbs.forEach((item) => {
              if (!uniqueMap0.has(item.estb)) {
                uniqueMap0.set(item.estb, item);
              }
            });
            this.formConfig[0].option =  [...uniqueMap0.values()];


            //持有方
            let rcPtys = this.tableData.map(item => {
              return {
                rcPty: item.rcPty,
                rcPtyNm: item.rcPtyNm
              };
            });
            const uniqueMap1 = new Map();
            rcPtys.forEach((item) => {
              if (!uniqueMap1.has(item.rcPty)) {
                uniqueMap1.set(item.rcPty, item);
              }
            });
            this.formConfig[1].option =  [...uniqueMap1.values()];

          }

        },
        search(data) {
            this.searchData = data || this.searchData;
            this.getTableData();
        },

        getTableData() {
            let params = {};
            const cstIds = this.userObj.cstIds.join(",");
            params = {
                // orderBy: this.pagination.sortField
                //     ? `${this.pagination.sortField} ${this.pagination.sortOrder == "ascend" ? "asc" : "desc"
                //     }`
                //     : "",
                estb: this.searchData.estb.key,
                rcPty: this.searchData.rcPty.key,
                exDayStart: this.searchData.exDay[0],
                exDayEnd: this.searchData.exDay[1],
                pageNum: this.pagination.current,
                pageSize: this.pagination.pageSize
            };
            this.loading = true;
            queryGoldPayFailApi(params,this.loading)
                .then((res) => {
                    this.selectedRowKeys = [];
                    this.selectedRows = [];
                    this.pagination.total = res.data.grid.total;
                    this.tableData = res.data.grid.list;
                    this.loading = false;
                    if(this.tableData){
                      this.getDataList(null);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                });
            // this.totalPayable()
        },
        toPaie(record){
          const self = this;
          this.$confirm({
            title: '兑付',
            content: "确定重新兑付祺信？",
            onOk() {
              paymentFailGld({gldId:record.gldId})
                .then(res => {
                    if(res.status === 200){
                      self.$message.success("兑付成功");
                    }
                  self.getTableData();
              }).catch((err) => {
                console.log(err);
                self.getTableData();
              });
            },
            onCancel() { }
          })
        },
      async toBatchPaie(){
          if(this.selectedRows){
            this.loading = true
            let gldIds = this.selectedRows.map(item => item.gldId).join(',');
            await paymentFailGld({gldIds:gldIds},this.loading)
              .then(res => {
                this.$message.success(res.description);
                this.loading = false;
              })
              .catch((err) => {
                console.log(err);
                this.loading = false;
            });
            this.getTableData();
          }
        },
        totalPayable() {
          queryGoldPayFailCount({})
            .then(res => {
              this.tableDataAmount = res.data.amount
            })
        }

    },
    activated() {

    }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/pages/bill-payment/gold-checks-paie-excepiton.vue